import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propStr } from '../../../../helpers/custom-prop-types';
import SeminarFillIcon from '../../../Icon/Svg/SeminarFillIcon';
import SquareAcademicCapIcon from '../../../Icon/Svg/SquareAcademicCapIcon';
const ConsultantSearchTabIcon = (props) => {
    const { icon } = props;
    if (icon === 'search') {
        return _jsx("i", Object.assign({ className: 'material-icons' }, { children: "supervisor_account" }));
    }
    if (icon === 'service') {
        return _jsx(SquareAcademicCapIcon, {});
    }
    if (icon === 'seminar') {
        return _jsx(SeminarFillIcon, {});
    }
    if (icon === 'slide' || icon === 'psSlide') {
        return _jsx("i", Object.assign({ className: 'material-icons' }, { children: "panorama" }));
    }
    return null;
};
ConsultantSearchTabIcon.propTypes = {
    icon: propStr().isRequired,
};
export default ConsultantSearchTabIcon;
